import axios, { AxiosError, AxiosResponse } from "axios";

import { apiConstants } from "../constants/api";
const instance = axios.create({
  baseURL: apiConstants.baseURL,
  headers: apiConstants.headers,
  timeout: 600000,
});

instance.interceptors.request.use((config) => {
  if (!config.url) return config;

  const currentUrl = new URL(config.url, config.baseURL);
  // parse pathName to implement variables
  Object.entries(config.urlParams || {}).forEach(([key, value]) => {
    currentUrl.pathname = currentUrl.pathname.replace(
      `:${key}`,
      encodeURIComponent(value)
    );
  });

  const authPart =
    currentUrl.username && currentUrl.password
      ? `${currentUrl.username}:${currentUrl.password}`
      : "";

  return {
    ...config,
    baseURL: `${currentUrl.protocol}//${authPart}${currentUrl.host}`,
    url: currentUrl.pathname,
  };
});
instance.interceptors.response.use(
  (response: AxiosResponse) => {
    // console.log("Successful response:", response); // <-- Add this line
    return response;
  },
  (error: AxiosError) => {
    if (error.response) {
      const status = error.response.status;
      // console.log("Status.......", status);
      switch (status) {
        case 400:
          console.error("Bad Request:", error.response.data);
          break;

        case 401:
          console.error("Unauthorized:", error.response.data);
          // Optionally redirect to login
          break;

        case 403:
          console.error("Forbidden:", error.response.data);
          break;

        case 404:
          console.error("Not Found:", error.response.data);
          break;

        case 500:
          console.error("Server Error:", error.response.data);
          break;
        case 502:
          console.error("Server Error:", error.response.data);
          break;

        default:
          console.error(`Error ${status}:`, error.response.data);
          break;
      }
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Axios error:", error.message);
    }

    return Promise.reject(error);
  }
);

export default instance;
